import { Integrations } from "@sentry/tracing"

export default {
  api: "/api",
  sentry: {
    dsn: "CHANGE_ME",
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
  },
}
